const upgradePersonal = {
  bannerTitle: 'HitPaw線上終極版',
  introduct:
    '獲得工具集中超過35種功能的會員高階權益，包括增強器、移除器、AI 翻譯器、螢幕錄製器等，只需一次即可獲得，價格實惠。',
  Upgrade: '升級',
  Tools: '工具包',
  MyProjects: '我的檔案',
  MyAccount: '我的帳戶',
  Subscription: '訂閱',
  LogOut: '登出',
  PopularTools: '流行工具',
  Enhance: '增強',
  Remove: '去除',
  Animate: '動起來',
  Extract: '提取',
  SaveThreeDays: '檔案儲存3天，請處理後下載。',
  All: '全部',
  Video: '影片',
  Image: '圖像',
  Audio: '音頻的',
  minutesAgo: '幾分鐘前',
  hoursAgo: '幾小時前',
  daysAgo: '幾天前',
  Modified: '修改的',
  Order: '排序',
  EarliestToLatest: '最早到最新',
  LatestToEarliest: '從最新到最早',
  NoProject: '沒有檔案。快速開始。',
  OnlineTools: '線上工具',
  AIVideoEnhancer: '人工智慧影片增強器',
  Enhancer4K: '一鍵AI在線增強影片至4K',
  AIPhotoEnhancer: '人工智慧照片增強器',
  AIEnhancerImage: 'AI在線無損增強圖像高達8倍',
  View: '檢視',
  Download: '下載',
  MultipleSelect: '多選',
  Delete: '刪除',
  SubscriptionHistory: '訂閱歷史',
  NoValidSubscription: '沒有有效的訂閱項目。',
  veContent: '一鍵AI在線增強視頻至4K',
  peContent: 'AI 在線無損增強圖像高達 8 倍',
  rmvContent: '去除視頻水印',
  rmttContent: '瞬間去除TikTok視頻水印',
  dynamicContent: '在線為您的照片製作動畫',
  rmbgContent: '從圖像中刪除背景',
  youMayNeed: '你可能需要',
  new: '新',
  loginYourAccount: '登錄您的 HitPaw 帳戶',
  signUpYourAccount: '註冊您的 HitPaw 帳戶',
  HitPawWatermark: '在線水印去除器',
  HitPawTiktokWatermark: '在線 TikTok 水印去除器',
  HitPawRemoveBg: '在線背景去除劑',
  dynamicTitle: 'HitPaw Online Animate Old Photos',
};
export default upgradePersonal;
